<template>
    <div class="bo-product-list">
        <div
            class="frame"
            v-for="item in productItems"
            :key="item.index"
        >
            <div class="frame-header">
                <div class="title">{{ item.title }}</div>
                <div class="link">
                    <a
                        :href="item.link"
                        class="links"
                    >
                        <span>{{ productListTranslations.shop_more ?? "SHOP MORE" }}</span>
                        <i class="icon-chevronright"></i>
                    </a>
                </div>
            </div>

            <div :class="['frame-content', isSlider ? '_slide' : '']">
                <ul
                    :id="isSlider ? 'autoWidth' : ''"
                    :class="isSlider ? 'cs-hidden' : ''"
                >
                    <li
                        v-for="product in item.details"
                        :key="product.index"
                    >
                        <a :href="product.product_details_url">
                            <div class="product-item">
                                <img
                                    :src="product.images"
                                    alt="Product Image"
                                    style="width: 100%"
                                />
                                <div class="product-details">
                                    <!-- <div v-if="product.expiry" class="sales-expiry">
                                        <span>Ends in {{ product.expiry }} Day(s)</span>
                                    </div> -->

                                    <div class="badges">
                                        <div
                                            v-if="product.serialNumber"
                                            class="serial-number"
                                        >
                                            {{ product.serialNumber }}
                                        </div>
                                        <div
                                            v-if="product.sku"
                                            class="sku"
                                        >
                                            {{ product.sku }}
                                        </div>
                                        <div
                                            v-if="product.stock"
                                            class="stock"
                                        >
                                            {{
                                                productListTranslations.amount_in_stock.replace(
                                                    ":amount",
                                                    product.stock
                                                ) ?? product.stock.concat(" In Stock")
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="product.name"
                                        class="product-name"
                                    >
                                        {{ product.name }}
                                    </div>
                                    <template v-if="canReadPrices">
                                    <div
                                        v-if="product.max_price != null"
                                        class="price"
                                    >
                                        {{ currencySymbol }}
                                        {{ addOrRemoveTaxIfNeeded(product.min_price, product.tax_class).toFixed(2) }} -
                                        {{ addOrRemoveTaxIfNeeded(product.max_price, product.tax_class).toFixed(2) }}
                                    </div>
                                    <div
                                        v-else-if="product.regular_price != null || product.sale_price != null || product.price != null"
                                        class="price"
                                    >
                                        {{ currencySymbol }}
                                        {{
                                            addOrRemoveTaxIfNeeded(
                                                product.sale_price ?? product.regular_price ?? product.price,
                                                product.tax_class
                                            ).toFixed(2)
                                        }}
                                    </div>
                                    </template>
                                </div>
                                <!-- <a
                                    :href="product.product_details_url"
                                    class="btn-rounded d-flex align-items-center"
                                    style="justify-content: center; margin-top: 10px"
                                >
                                    View Details
                                </a> -->
                                <!-- <div v-if="product.sku" class="sku">
                                    {{ product.sku }}
                                </div> -->
                                <div
                                    v-if="product.stock"
                                    class="stock"
                                >
                                    {{
                                        productListTranslations.amount_in_stock.replace(":amount", product.stock) ??
                                        product.stock.concat(" In Stock")
                                    }}
                                </div>
                            </div>
                        </a>
                        <!-- <div v-if="product.name" class="product-name">
                            {{ product.name }}
                        </div> -->
                        <!-- <div
                            v-if="product.max_price != null"
                            class="price"
                        >
                            {{ currencySymbol }}
                            {{ addOrRemoveTaxIfNeeded(product.min_price, product.tax_class).toFixed(2) }} -
                            {{ addOrRemoveTaxIfNeeded(product.max_price, product.tax_class).toFixed(2) }}
                            <bo-point
                                v-if="pointConfig != false"
                                :value="calculatePoint(addOrRemoveTaxIfNeeded(product.min_price, product.tax_class))"
                            ></bo-point>
                        </div> -->
                        <!-- <div v-if="product.max_price != null" class="price">
                            {{currencySymbol}} {{ product.min_price.toFixed(2) }}
                            <bo-point v-if="pointConfig != false" :value="calculatePoint(product.min_price)"></bo-point>
                        </div> -->
                        <!-- <div
                            v-else-if="product.price"
                            class="price"
                        >
                            {{ currencySymbol }}
                            {{ addOrRemoveTaxIfNeeded(product.regular_price, product.tax_class).toFixed(2) }}
                            <bo-point
                                v-if="pointConfig != false"
                                :value="calculatePoint(addOrRemoveTaxIfNeeded(product.price, product.tax_class))"
                            ></bo-point>
                        </div> -->
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import BoPoint from "js/frontend/components/bo-point.vue";
import { priceVisibilityMixin } from "js/frontend/mixins/price-visibility.js";
Vue.component("bo-point", BoPoint);

export default {
    components: { BoPoint },

    mixins: [priceVisibilityMixin],

    props: {
        productItems: {
            type: Array,
            default: "",
        },
        pointConfig: {
            type: [Object, Boolean],
            default: null,
        },
        taxIncluded: {
            type: Boolean,
            default: null,
        },
        displayPricesDuringCartAndCheckoutIncludingTax: {
            type: Boolean,
            default: null,
        },
        isSlider: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            currencySymbol: window.bo?.currencySymbol ?? "",
            generalTranslations: window.bo?.generalTranslations ?? {},
            productListTranslations: window.bo?.productListTranslations ?? {},
        };
    },

    methods: {
        calculatePoint(productPrice) {
            return (
                parseFloat(this.pointConfig?.tier_multiplier ?? 0) *
                productPrice *
                (this.pointConfig?.conversion_rate ?? 0)
            );
        },

        addOrRemoveTaxIfNeeded(price, taxClass) {
            if (this.taxIncluded == this.displayPricesDuringCartAndCheckoutIncludingTax || !taxClass) {
                return price;
            }
            if (!this.taxIncluded && this.displayPricesDuringCartAndCheckoutIncludingTax) {
                return price * (1 + taxClass.percentage / 100);
            }
            if (this.taxIncluded && !this.displayPricesDuringCartAndCheckoutIncludingTax) {
                return price / (1 + taxClass.percentage / 100);
            }
        },
    },
};
</script>

<style>
.lSSlideOuter {
    margin: 0 !important;
}
</style>
